import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { Salircliente } from 'utils/constantes';
import { ReportarEfectivoCompra, EnviarmensajeWhastapp } from "../../../utils/Query";
import { useDispatch, useSelector } from 'react-redux';
import { setModal } from 'StoreRedux/Slice/SuscritorSlice';
import { setToastes } from 'StoreRedux/Slice/ToastSlice';
import { carrusel } from 'views/Pages/Flasdeticket/imagenstatctic';
let { facilito, redacti } = carrusel
import SweetAlert from 'react-bootstrap-sweetalert';
import { FacturaComnet } from 'utils/constantes';
import { Triangle } from 'react-loader-spinner';
import { GetValores } from 'utils/CarritoLocalStorang';
import { PagoRapido } from 'utils/Querycomnet';
import SeccionFisicosVenta, { useBoletosFisicosVenta } from 'views/Components/BoletosFisicos/SeccionFisicosVenta';
import { bancos } from 'utils/Imgenesutils';
import ReactGA from 'react-ga4';
let { atencion } = bancos
const ModalEfectivofACILITO = (props) => {

  const TRACKING_ID = "G-LJN507B5NX";
  ReactGA.initialize(TRACKING_ID);
  const { intervalo, detener, detenervelocidad } = props;
  const {
    setDatoToas, setrepShow, comprar,
  } = props
  let usedispatch = useDispatch()
  let Modalshow = useSelector((state) => state.SuscritorSlice.modal)
  const [alert, setAlert] = useState(null)
  const [spinerst, seTSpiners] = useState("d-none")
  // Boletos fisicos entregados en la venta (solo personal)
  const fisicos = useBoletosFisicosVenta()
  async function Guardarcompraefectivo() {
    try {
      const mensaje = await ReportarEfectivoCompra()
      const { msg } = mensaje
      if (msg != null) {
        efectiOpShow(false)
        Salircliente()
        setDatoToas({
          message: 'En breve uno de nuestros colaboradores se comunicará con usted',
          color: 'bg-success',
          estado: "" + msg,
        })
        detener()
      }
    } catch (error) {
    }
  }
  function comnetusernew() {
    seTSpiners("")
    hideAlert()
    let valores = GetValores()
    PagoRapido("").then(ouput => {
      if (ouput && ouput.success && (ouput.idRegistro || ouput.id)) fisicos.asignar(ouput.idRegistro || ouput.id).then((res) => { if (res) usedispatch(setToastes({ show: true, message: res.texto, color: res.ok ? 'bg-success' : 'bg-warning', estado: 'Boletos físicos' })) })
      if (!ouput.success) {
        detener()
        usedispatch(setToastes({
          show: true, message: 'Hubo un error ', color: 'bg-warning', estado:
            "No se genero la orden intente de nuevo"
        }))
        seTSpiners("d-none")
        hideAlert()
        return
      }
      else {
        detenervelocidad()
        window.gtag('event', 'begin_checkout', {
          transaction_id: "T_" + ouput.idRegistro,  // ID único de la transacción
          value: ouput.valores.subtotal, // Valor total
          tax: ouput.valores.iva,
          affiliation: "Tienda Online", // Nombre de la tienda o sitio
          currency: 'USD', // Moneda

          items: ouput.concierto.map(item => ({
            item_name: item.localidad_nombre,
            item_id: item.id_localidad,
            price: item.localidad_precio,
            item_list_name: item.nombreConcierto,
            quantity: item.cantidad,
            item_category: "COMNET"
          }))
        });
        
        detener()
        sessionStorage.setItem(FacturaComnet, JSON.stringify(ouput.idfactura))
        // total_recaudacion: lo que se paga en el banco (total + recargo, lo calcula el backend)
        usedispatch(setModal({ nombre: 'ordendepago', estado: { ...valores, total_recaudacion: ouput.total_recaudacion, idRegistro: ouput.idRegistro } }))
        usedispatch(setToastes({ show: true, message: 'Orden de pago generada', color: 'bg-success', estado: ouput.message }))
        // usedispatch(setToastes({nombre:""}))      
       
        seTSpiners("d-none")
        hideAlert()
        window.gtag('event', 'purchase', {
          transaction_id: "T_" + ouput.idRegistro,  // ID único de la transacción
          value: ouput.valores.subtotal, // Valor total
          tax: ouput.valores.iva,
          affiliation: "Tienda Online", // Nombre de la tienda o sitio
          currency: 'USD', // Moneda

          items: ouput.concierto.map(item => ({
            item_name: item.localidad_nombre,
            item_id: item.id_localidad,
            price: item.localidad_precio,
            item_list_name: item.nombreConcierto,
            quantity: item.cantidad,
            item_category: "COMNET"
          }))
        });
        
      }
    }).catch(error => {
      seTSpiners("d-none")
    })
  }
  const cerrar = () => {
    // setDetalle(true)
    detenervelocidad()
    usedispatch(setModal({ nombre: '', estado: '' }))
    hideAlert()
  }

  const succesExit = () => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}


        closeOnClickOutside={false}
        showCancel={false}
        showConfirm={false}
        confirmBtnText="Completar  Compra"
        cancelBtnText="Anular Compra"
        closeAnim={{ name: 'hideSweetAlert', duration: 500 }}

      >
        <div >
          <div className='col-12 pb-3'>
            <img src={atencion} className="img-fluid"
              style={{
                height: 100
              }}
            ></img>


          </div>
          <div>
            <h6 className=' col-9 col-md-12  mx-auto' style={{
              fontWeight: "bold",
              fontSize: "1.0rem"
            }}>¿Quieres abandonar tu proceso de compra?</h6>
            <p> No puedes guardar tu proceso y continuar luego. Si, abandonas perderás tus reservas
            </p>
            <p>  </p>
          </div>


        </div>
        <div className='d-flex  justify-content-around py-4'>
          <div>
            <button className='btn btn-outline-danger  rounded-6' onClick={() => cerrar()}>

              <span style={{
                fontWeight: "bold"
              }}>Anular Compra</span>
            </button>
          </div>
          <div>
            <button className=' btn btn-warning rounded-5' onClick={() => comnetusernew()} >
              <span style={{
                fontWeight: "bold"
              }}> Completar Compra</span>
            </button>
          </div>

        </div>

      </SweetAlert>
    )
  }
  const succesAlert = () => {
    setAlert(
      <SweetAlert

        style={{ display: "block", marginTop: "-100px" }}

        closeOnClickOutside={false}
        showCancel={false}
        showConfirm={false}
        closeAnim={{ name: 'hideSweetAlert', duration: 500 }}

      >
        <div className='col-12 pb-3'>
          <img src={atencion} className="img-fluid"
            style={{
              height: 100
            }}
          ></img>


        </div>
        <h6 className=' col-9 col-md-12  mx-auto' style={{
          fontWeight: "bold",
          fontSize: "1.0rem"
        }}>Desea continuar con la compra</h6>
        <p>Se generará una orden de pago con el cual deberá cancelar la compra</p>
        <div className='d-flex  justify-content-around py-4'>
          <div>
            <button className='btn btn-outline-danger  rounded-6' onClick={() => hideAlert()}>

              <span style={{
                fontWeight: "bold"
              }}>Cancelar</span>
            </button>
          </div>
          <div>
            <button className=' btn btn-warning rounded-5' onClick={() => comnetusernew()} >
              <span style={{
                fontWeight: "bold"
              }}>Comfirmar</span>
            </button>
          </div>

        </div>
      </SweetAlert>
    )
  }
  const hideAlert = () => {
    setAlert(null)
  }
  useEffect(() => {
    seTSpiners("d-none")
  }, [Modalshow.nombre == "modalpagoFacilito" ? true : false])
  return (
    <>
      {alert}
      <Modal
        show={Modalshow.nombre == "modalpagoFacilito" ? true : false}
        fullscreen={'md-down'}
      >
        <Modal.Header className='py-3  bg-dark ' >
          <div className='d-flex justify-content-between w-100' >
            <h5 className="modal-title text-center justify-content-center align-items-center" style={{ fontWeight: "bold", fontSize: '1.2em' }}>Tiempo restante de compra <span className="text-danger" >{intervalo} </span></h5>
            <button className="btn btn-outline-light" onClick={() => succesExit()}>
              <i className="fa fa-arrow-left"></i>
              <span className="mx-1">Salir</span>
            </button>
          </div>
          <button type="button" className=" close"
            onClick={() => succesExit()} >
            X
          </button>
        </Modal.Header>
        <Modal.Body className=' d-flex flex-column justify-content-center align-items-center'>
          <div className="w-100"><SeccionFisicosVenta fisicos={fisicos} idLector="lector-fisico-facilito" /></div>

          <div className="row d-flex px-2 pagos  border rounded-3 h-70 " >
            <h3 className='text-center'> Puede terminar la compra en : </h3>
            <div className="container-fluid d-flex flex-column p-3 px-0 col-12">
              <div className="   d-flex justify-content-center    px-0 mx-0">
                <img src={"https://api.t-ickets.com/store/img/puntos.png"} style={{

                }} className=" img-fluid"
                  onClick={succesAlert}
                />

              </div>
              <div className="row pagos d-none d-flex justify-content-center   m-1 p-2">
                <img src={"https://api.t-ickets.com/store/img/puntos.png"} className=" img-fluid   " />
              </div>
              <div className="col-12  d-flex  justify-content-center  p-1 mt-2">
              </div>
            </div>
          </div>


          <div>
            <div className={spinerst}
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: '1000'
              }}
            >

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '10px',
                padding: '10px',
              }}>
                <Triangle
                  height="80"
                  width="80"
                  color="#4fa94d"
                  ariaLabel="triangle-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
                <h4 className='text-light'>Creando orden de pago</h4>


              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

    </>
  )

}

export default ModalEfectivofACILITO;